import { localStore } from 'utils/extra';

const RR_BLOCKED_STORES_IDS = [
  'paragonfitwear',
  'wearnala',
  'cvlinens',
  'jordancraig',
  'springstepshoes',
  'lysse',
  'neveneyewear',
  'ninelineapparel',
  'brixtonllc',
  'lotusandluna'
];

export default function isLogRocketDisabled() {
  const isSSR = localStore.get('store_type') === 'SSR';
  const url = (window.location.href || '').toLowerCase();
  return !isSSR && RR_BLOCKED_STORES_IDS.some(storeId => url.includes(storeId));
}
